import StyledLogger from 'vimmi-web-utils/cjs/logger';

const $logger = new StyledLogger('Player', {
  debug: {
    active: true,
    level: StyledLogger.TRACE_LEVEL
  }
});

export default $logger;